export const AREAS_DATA = {
  "igi-airport": {
    num: "01",
    name: "IGI Airport (DEL)",
    title: "Rooms near IGI Airport, Delhi",
    seoDesc: "Verified rooms 6–7 km from IGI Airport Delhi for layovers and early flights. Actual room photos on chat before payment. T1, T2, T3 terminal guidance.",
    img: "/images/hero.webp",
    intro:
      "Landing at Terminal 1, 2 or 3 — or flying out at an odd hour? We arrange verified rooms on the airport side of Delhi, 6–7 km from the terminals, so your layover, early departure or late arrival stays effortless.",
    facts: [
      { k: "Rooms we arrange", v: "6–7 km from airport", p: "Quick transfers for early departures and late-night arrivals." },
      { k: "Terminal shuttle", v: "Free, ~every 20 min", p: "Landside shuttle connects T1, T2 and T3 for boarding-pass holders." },
      { k: "T1 departures", v: "Mahipalpur / Dwarka side", p: "Often quicker than the T3 side for domestic low-cost flights." },
      { k: "Terminal change", v: "Allow ~3 hours", p: "Re-check, security and road transfer take longer than expected." },
    ],
    know: [
      "T1 handles domestic low-cost flights, T2 selected domestic flights, and T3 all international plus full-service domestic flights.",
      "Always verify your terminal on the airline ticket — assignments can change.",
      "For overnight layovers we suggest rooms on the same side as your departure terminal to avoid cross-city transfers.",
      "Airport pickup and drop can be added to any room enquiry — sedan or XL, priced upfront.",
    ],
    hi: {
      name: "IGI एयरपोर्ट (DEL)",
      title: "IGI एयरपोर्ट, दिल्ली के पास कमरे",
      intro:
        "टर्मिनल 1, 2 या 3 पर उतर रहे हैं — या अजीब समय की उड़ान है? हम दिल्ली की एयरपोर्ट साइड, टर्मिनलों से 6–7 किमी दूर, सत्यापित कमरे कराते हैं — ताकि ले-ओवर, सुबह की उड़ान या देर रात का आगमन आसान रहे।",
      facts: [
        { k: "हमारे कराए कमरे", v: "एयरपोर्ट से 6–7 किमी", p: "सुबह की उड़ान और देर रात आगमन के लिए आसान ट्रांसफर।" },
        { k: "टर्मिनल शटल", v: "मुफ्त, ~हर 20 मिनट", p: "बोर्डिंग पास धारकों के लिए लैंडसाइड शटल T1, T2 और T3 को जोड़ती है।" },
        { k: "T1 उड़ानें", v: "महिपालपुर / द्वारका साइड", p: "घरेलू लो-कॉस्ट उड़ानों के लिए अक्सर T3 साइड से तेज़।" },
        { k: "टर्मिनल बदलाव", v: "~3 घंटे का समय रखें", p: "री-चेक, सिक्योरिटी और रोड ट्रांसफर में उम्मीद से ज़्यादा समय लगता है।" },
      ],
      know: [
        "T1 घरेलू लो-कॉस्ट उड़ानें, T2 चुनिंदा घरेलू उड़ानें, और T3 सभी अंतरराष्ट्रीय व फुल-सर्विस घरेलू उड़ानें संभालता है।",
        "अपनी एयरलाइन टिकट पर टर्मिनल ज़रूर जाँचें — असाइनमेंट बदल सकता है।",
        "रात के ले-ओवर के लिए हम डिपार्चर टर्मिनल वाली साइड के कमरे सुझाते हैं, ताकि शहर के पार ट्रांसफर से बचा जा सके।",
        "किसी भी पूछताछ के साथ एयरपोर्ट पिकअप या ड्रॉप जोड़ा जा सकता है — सेडान या XL, पहले से तय कीमत पर।",
      ],
    },
  },
  yashobhoomi: {
    num: "02",
    name: "Yashobhoomi Convention Centre",
    title: "Rooms near Yashobhoomi, Dwarka Sector 25",
    seoDesc: "Rooms just 3–4 km from Yashobhoomi Convention Centre (IICC), Dwarka Sector 25 and 6–7 km from IGI Airport. Photos on chat before payment. Ideal for expos and events.",
    img: "/images/yashobhoomi.webp",
    intro:
      "Attending an expo, conference or concert at India International Convention & Expo Centre? Rooms we arrange sit just 3–4 km from the venue — skip the cross-city commute and reach the venue fresh.",
    facts: [
      { k: "To the venue", v: "3–4 km", p: "Rooms we arrange are a short drive from Yashobhoomi, Dwarka Sector 25." },
      { k: "To IGI Airport", v: "6–7 km", p: "Easy transfers for early flights before or after your event." },
      { k: "Metro access", v: "Airport Express Line", p: "Yashobhoomi Dwarka Sector 25 station sits right at the venue." },
      { k: "Event days", v: "Keep a buffer", p: "Large expos bring security queues and road congestion — arrive early." },
    ],
    know: [
      "Ideal for exhibitors, delegates and event visitors who want early mornings without a long commute.",
      "Rooms toward Dwarka and the airport side keep you within a short drive of the venue.",
      "Breakfast-inclusive packages are popular with multi-day conference visitors.",
      "Tell us your event dates — availability around big expos sells out early.",
    ],
    hi: {
      name: "यशोभूमि कन्वेंशन सेंटर",
      title: "यशोभूमि, द्वारका सेक्टर 25 के पास कमरे",
      intro:
        "इंडिया इंटरनेशनल कन्वेंशन एंड एक्सपो सेंटर में एक्सपो, कॉन्फ्रेंस या कॉन्सर्ट? हमारे कराए कमरे वेन्यू से सिर्फ 3–4 किमी दूर हैं — शहर के पार की भागदौड़ छोड़िए और तरोताज़ा पहुँचिए।",
      facts: [
        { k: "वेन्यू की दूरी", v: "3–4 किमी", p: "हमारे कराए कमरे यशोभूमि, द्वारका सेक्टर 25 से कुछ ही मिनट की दूरी पर।" },
        { k: "IGI एयरपोर्ट", v: "6–7 किमी", p: "इवेंट से पहले या बाद में सुबह की उड़ान के लिए आसान ट्रांसफर।" },
        { k: "मेट्रो", v: "एयरपोर्ट एक्सप्रेस लाइन", p: "यशोभूमि द्वारका सेक्टर 25 स्टेशन वेन्यू के ठीक पास है।" },
        { k: "इवेंट के दिन", v: "समय का मार्जिन रखें", p: "बड़े एक्सपो में सिक्योरिटी लाइन और ट्रैफिक होता है — जल्दी निकलें।" },
      ],
      know: [
        "प्रदर्शकों, प्रतिनिधियों और विज़िटर के लिए बढ़िया — बिना लंबे सफ़र के सुबह जल्दी वेन्यू पहुँचें।",
        "द्वारका और एयरपोर्ट साइड के कमरे वेन्यू से कुछ ही मिनट की दूरी पर रखते हैं।",
        "कई दिनों की कॉन्फ्रेंस में नाश्ते वाले पैकेज लोकप्रिय हैं।",
        "अपनी इवेंट डेट बताएं — बड़े एक्सपो के समय कमरे जल्दी भर जाते हैं।",
      ],
    },
  },
  "kapashera-border": {
    num: "03",
    name: "Kapashera Border",
    title: "Rooms near Kapashera Border, Delhi–Gurgaon",
    seoDesc: "Value rooms near Kapashera Border on the Delhi–Gurgaon NH-48 corridor, 6–7 km from IGI Airport. Actual photos on chat before payment.",
    img: "/images/kapashera.webp",
    intro:
      "On the Delhi–Gurugram highway corridor, Kapashera works well for airport access and Gurgaon-side travel alike — practical stays without city-centre prices.",
    facts: [
      { k: "Corridor", v: "NH-48 · Delhi–Gurugram", p: "Right on the old Delhi–Gurgaon road, near the toll plaza side." },
      { k: "To IGI Airport", v: "6–7 km · 15–20 min", p: "Traffic on the highway varies — keep margin at peak hours." },
      { k: "Gurgaon access", v: "Direct", p: "Straight run toward Udyog Vihar and the Gurgaon business districts." },
      { k: "Value stays", v: "Budget friendly", p: "Sensible rooms for transit, work trips and family halt-overs." },
    ],
    know: [
      "A practical base when your work or family visit spans both Delhi and Gurgaon.",
      "Highway-side stays make early airport drops straightforward.",
      "Peak-hour traffic on the Delhi–Gurugram road can be heavy — we advise timing at booking.",
      "Airport pickup can be arranged from any Kapashera-side hotel we confirm for you.",
    ],
    hi: {
      name: "कपशेरा बॉर्डर",
      title: "कपशेरा बॉर्डर, दिल्ली–गुड़गांव के पास कमरे",
      intro:
        "दिल्ली–गुड़गांव हाईवे कॉरिडोर पर कपशेरा एयरपोर्ट और गुड़गांव, दोनों तरफ़ के सफ़र के लिए सुविधाजनक है — शहर के केंद्र जैसी कीमत के बिना व्यावहारिक ठहराव।",
      facts: [
        { k: "कॉरिडोर", v: "NH-48 · दिल्ली–गुड़गांव", p: "पुरानी दिल्ली–गुड़गांव रोड पर, टोल प्लाज़ा के पास।" },
        { k: "IGI एयरपोर्ट", v: "6–7 किमी · 15–20 मिनट", p: "हाईवे का ट्रैफिक बदलता रहता है — पीक आवर में मार्जिन रखें।" },
        { k: "गुड़गांव", v: "सीधी पहुँच", p: "उद्योग विहार और गुड़गांव बिज़नेस डिस्ट्रिक्ट का सीधा रास्ता।" },
        { k: "किफायती ठहराव", v: "बजट फ्रेंडली", p: "ट्रांज़िट, वर्क ट्रिप और फैमिली हॉल्ट के लिए समझदार कमरे।" },
      ],
      know: [
        "जब काम या फैमिली विज़िट दिल्ली और गुड़गांव दोनों में हो, तो यह व्यावहारिक बेस है।",
        "हाईवे के किनारे के कमरे सुबह की एयरपोर्ट ड्रॉप आसान बनाते हैं।",
        "दिल्ली–गुड़गांव रोड पर पीक आवर का ट्रैफिक भारी हो सकता है — बुकिंग के समय हम सही समय बता देते हैं।",
        "जिस भी कपशेरा-साइड होटल की हम पुष्टि करें, वहाँ से एयरपोर्ट पिकअप कराया जा सकता है।",
      ],
    },
  },
};

export const AREA_LIST = [
  { slug: "igi-airport", name: "IGI Airport", km: "Airport · 6–7 km" },
  { slug: "yashobhoomi", name: "Yashobhoomi", km: "Venue · 3–4 km" },
  { slug: "kapashera-border", name: "Kapashera Border", km: "NH-48 · 6–7 km" },
];
